module.exports = __webpack_public_path__ + "img/taoyuan-4.a80f992c.jpg";